export const min = (x: number, y: number) => x < y ? x : y
